import React from 'react';
import { css, useTheme } from "@emotion/react";

import FooterTopMenuBox from "core/Components/Footer/FooterTopMenuBox";
import Image from "core/Components/Image";

import st4sBadge from "images/badges/ST4S_Badge_2024_Colour.png";
import wtbLogo from "images/wtb-2-lines-blue-v1.png";

type Props = {
    footerTopMenu: [any] | undefined,
    onMoveToHome: () => void,
};

const FooterTopLeftSection:React.FC<Props> = ({ footerTopMenu, onMoveToHome }) => {
    const theme = useTheme();

    const style = css`
        display: flex;
        align-items: end;
        margin-top: 50px;
        margin-bottom: 5px;
        width: 100%;

        ${theme.breakpoints.down('md')} {
            justify-content: space-between;
            margin-bottom: 22px;
        }

        ${theme.breakpoints.down('xs')} {
            flex-direction: column;
            gap: 12px;
            align-items: start;
        }
    `;

    const imageContainerStyle = css`
        display: flex;
        align-items: center;
    `;

    const imageStyle = css`
        width: 240px;
        height: unset;

        ${theme.breakpoints.down('md')} {
            margin-bottom: 10px;
            width: 130px;
        }
    `;

    const badgeImageStyle = css`
        margin-left: 50px;
        width: 130px;
        height: 143px;
        
        ${theme.breakpoints.down('md')} {
            display: none;
        }
    `;

    const menuStyle = css`
        ${theme.breakpoints.up('sm')} {
            margin-left: 40px;
        }
    `;

    return (
        <div css={style}>
            <div css={imageContainerStyle}>
                <Image image={wtbLogo} onClickHandler={onMoveToHome} css={imageStyle} />
                <Image image={st4sBadge} css={badgeImageStyle} />
            </div>
            <div css={menuStyle}>
                <FooterTopMenuBox footerTopMenu={footerTopMenu} />
            </div>
        </div>
    );
};

export default FooterTopLeftSection;